export const SUPPORT_URL = 'mailto:support@leadsmania.ru';
